<template>
  <div class="friend-list" :class="{ open: isOpen }">
    <div class="panel-switch" @click="isOpen = !isOpen" title="在线用户列表">
      <span v-show="!isOpen" class="open"><i class="el-icon-arrow-left"></i></span>
      <span class="text">在线{{ onlineUsers.length }}人</span>
      <span v-show="isOpen" class="close"><i class="el-icon-arrow-right"></i></span>
    </div>
    <div class="panel">
      <div class="friend-list__title">在线用户
        <span class="online_count">{{ onlineUsers.length }}人在线</span>
      </div>
      <div class="friend-list__items">
        <div class="friend-item" :class="{self: $store.state.userInfo.id == friend.userId }" v-for="friend in onlineUsers" :key="friend.userId" @click="handleClick(friend)">
          <div class="friend-item__avatar" :style="{ backgroundColor: getNameColor(friend.fullName) }">
            {{ friend.fullName.charAt(0) }}
          </div>
          <div class="friend-item__info">
            <div class="friend-item__name">{{ friend.fullName }}
            </div>
            <div class="friend-item__signature">{{ friend.sign }}</div>
          </div>
          <div class="friend-item__status" :class="{ online: true }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onlineList',
  data() {
    return {
      isOpen: false,
      friends: [
        { id: 1, fullName: '张三', sign: '今天天气真好', online: true, color: '#4CAF50' },
        { id: 2, fullName: '李四', sign: '正在学习Vue', online: true, color: '#2196F3' },
        { id: 3, fullName: '王五', sign: '周末去爬山', online: false, color: '#FF9800' },
        { id: 4, fullName: '赵六', sign: '代码改变世界', online: true, color: '#9C27B0' },
        { id: 5, fullName: '孙七', sign: '爱生活爱编程', online: false, color: '#F44336' },
      ],
    };
  },
  methods: {
    handleClick(friend) {
      this.$emit('friend-click', friend);
    },
    // 根据名称生成颜色
    getNameColor(name) {
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }

      const hue = Math.abs(hash) % 360;
      const saturation = 65 + (Math.abs(hash) % 10);
      const lightness = 45 + (Math.abs(hash) % 10);

      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
  },
  computed: {
    onlineUsers: function () {
      return this.$store.state.onlineUsers;
    },
  },
};
</script>

<style scoped>
.friend-list {
  position: fixed;
  z-index: 9;
  right: -240px;
  top: 20%;
  height: 60%;

  width: 240px;
  background: #fff;
  border-radius: 12px;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.08);
  transition: all .3s;
}
.panel-switch{
  position: absolute;
  width: 30px;
  height: 80px;
  left: -28px;
  top: calc(50% - 40px);
  z-index: 0;
  color: #39cef7;
  background: #fff;
  line-height: 15px;
  /* border: 1px solid #d2d2d2; */
  box-shadow: -4px 0 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px 2px 2px 10px;
  border-right: none;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
.panel-switch .text{
  width: 18px;
}
.panel-switch .open, .panel-switch .close {
  width: 12px;
}
.panel{
  position: relative;
  height: 100%;
  z-index: 1;
  opacity: 0;
  transition: all .3s;
}
.friend-list.open {
  right: 10px;
}
.friend-list.open .panel {
  opacity: 1;
}

.friend-list__title {
  padding: 15px 20px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}
.online_count{
  color: #999;
  font-size: 12px;
  float: right;
  font-weight: normal;
}
.friend-list__items{
  height: calc(100% - 91px);
  line-height: 20px;
  overflow: auto;
  padding: 10px 0;
}
.friend-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.2s;
}

.friend-item:hover {
  background: #f5f7fa;
}

.friend-item__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  flex-shrink: 0;
}

.friend-item__info {
  flex: 1;
  margin-left: 12px;
  min-width: 0;
}

.friend-item__name {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.friend-item__signature {
  font-size: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.friend-item__status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
  flex-shrink: 0;
  margin-left: 8px;
}

.friend-item__status.online {
  background: #4CAF50;
}
.self{
  border-left: 2px solid #39cef7;
}
</style>